const commonPhoneScams = {
  slug: 'common-phone-scams',
  title: 'Common phone scams',
  description:
    'Learn how impersonation, tech support, bank fraud, and other phone scams work so you can spot them before you lose money or data.',
  category: 'scams',
  guideType: 'overview',
  readMinutes: 5,
  partnerTip: 'none',
  relatedSlugs: ['red-flags', 'what-not-to-do', 'after-a-scam-call'],
  sections: [
    {
      type: 'paragraph',
      text: 'Phone scammers rely on speed and emotion. They want you to act before you think. Most scams fit a few familiar patterns — once you know them, suspicious calls are easier to recognize.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Impersonation scams',
    },
    {
      type: 'paragraph',
      text: 'The caller pretends to be your bank, a government agency, a utility, or a well-known company. They claim there is fraud on your account, unpaid tax, or a legal problem that must be fixed immediately.',
    },
    {
      type: 'list',
      items: [
        'Pressure to stay on the line and not tell anyone',
        'Requests for passwords, PINs, or one-time codes',
        'Demands to move money to a “safe” account',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Tech support scams',
    },
    {
      type: 'paragraph',
      text: 'You are told your computer or phone is infected, or that your cloud account was hacked. The scammer may ask you to install remote-access software or pay for fake support.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Prize, lottery, and investment scams',
    },
    {
      type: 'paragraph',
      text: 'You “won” something you never entered, or you are offered guaranteed returns. They need a fee, tax payment, or crypto transfer upfront.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Remote access and refund scams',
    },
    {
      type: 'paragraph',
      text: 'A caller offers a refund you did not request, then asks you to log into your bank while they watch, or to install software. Their goal is to steal credentials or move money out.',
    },
    {
      type: 'tip',
      text: 'Look up the number on WhoDatNumber and read community reports before you call back or return a missed call.',
    },
    {
      type: 'lookupCta',
    },
    {
      type: 'link',
      to: '/learn/after-a-scam-call',
      label: 'Think you already gave information? See our after-a-scam-call checklist',
    },
  ],
};

export default commonPhoneScams;

